import { render, staticRenderFns } from "./WarnConfigInfo.vue?vue&type=template&id=b08692ea&scoped=true&"
import script from "./WarnConfigInfo.vue?vue&type=script&lang=js&"
export * from "./WarnConfigInfo.vue?vue&type=script&lang=js&"
import style0 from "./WarnConfigInfo.vue?vue&type=style&index=0&id=b08692ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08692ea",
  null
  
)

export default component.exports